import React from 'react';
import { connect } from 'react-redux';
import { FaArrowLeft } from 'react-icons/lib/fa';

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({
});

class CookiePolicy extends React.Component {
    
    redirect = () => {
        this.props.history.goBack();
    }
    
    render() {
        
        return (
            <div className="index-page">
                <br />
                <span onClick={this.redirect} title='back' className='nwmCol backArr'>
                    <FaArrowLeft />
                </span>
                <div className="container page container_t">
                    <div className='col-md-12'>
                        <div className="grid__item desk--one--whole">
                            <div className="comp-rich-text ">
                                <h5><strong><span className="intro-copy">Cookies Policy</span></strong></h5>
                            </div>
                            <br/>
                            <div className="comp-rich-text ">
                                <p>This notice explains how we use cookies and similar technologies on our websites and mobile applications to help provide you with the best possible online experience. New regulations will change the way in which the use of cookies is governed in the future and we’ll update this notice once those changes come into effect.<br />
                                    &nbsp;</p>
                            </div>
                            <div className="comp-rich-text ">
                                <h5>Your online privacy</h5>
                                <br/>
                                <p>You can visit our website without telling us who you are or revealing any information about yourself.&nbsp; However, if you give us any personal information about yourself or others we promise to treat it securely, fairly and lawfully.&nbsp; We are committed to protecting your privacy.</p>
                                <p>When we ask you for personal information online it will only be in response to you actively applying for or using one of our online products or services.</p>
                                <p>If you are giving us information for the first time we shall explain the purposes for which we shall use it at that time. If you are a customer already, this explanation will be in our Privacy Notice which you can find here.</p>
                                <p>We may use personal information you provide for the purpose of providing more relevant content to you.<br />
                                    &nbsp;</p>
                            </div>
                            <div className="comp-rich-text ">
                                <h5>Cookies – what are they?<br />
                                    &nbsp;</h5>
                                <p>A “cookie” is a small text file that’s stored on your computer, tablet or phone when you visit a website.</p>
                                <p>Some cookies are deleted when you close down your browser.&nbsp; These are known as session cookies.&nbsp; Others remain on your device until they expire or you delete them from your cache.&nbsp; These are known as persistent cookies and enable us to remember things about you as a returning visitor.</p>
                                <p>To find out more about cookies, including how to see what cookies have been set and how to manage and delete them, visit <a href="http://www.allaboutcookies.org/">www.allaboutcookies.org</a>. Alternatively, you can search the internet for other independent information on cookies.<br />
                                    &nbsp;</p>
                            </div>
                            <div className="comp-rich-text ">
                                <h5>Cookies – how we use them</h5>
                                <br/>
                                <p>If you delete cookies relating to this website we will not remember things about you, including your cookie preferences, and you will be treated as a first-time visitor the next time you visit the site.</p>
                                <p>We use cookies (and other similar technologies) to:</p>
                                <ul>
                                    <li>Provide products and services that you request and to provide a secure online environment</li>
                                    <li>Manage our marketing relationships</li>
                                    <li>Give you a better online experience and track website performance</li>
                                    <li>Help us make our website more relevant to you.</li>
                                </ul>
                                <p>Here we explain a bit more about each of these types and how you can control their use.<br />
                                    &nbsp;</p>
                            </div>
                            <div className="comp-rich-text ">
                                <h5>Cookies that are essential for us to provide a product or service you have requested and to provide a secure online environment</h5>
                                <br/>
                                <p>Without cookies we are unable to provide some products or services that you might request.&nbsp; Other ‘essential’ cookies keep our website secure.&nbsp; Even if you say “No” to cookies on this website we’ll continue to use these ‘essential’ cookies.</p>
                                <p>Essential cookies are used to:</p>
                                <ul>
                                    <li>deliver interactive services, such as:<ul>
                                        <li>online&nbsp;trading</li>
                                        <li>product applications</li>
                                        <li>web chat</li>
                                    </ul>
                                    </li>
                                    <li>maintain online security and protect against online fraud</li>
                                    <li>record your preference regarding our use of cookies on your device<br />
                                        &nbsp;</li>
                                </ul>
                            </div>
                            <div className="comp-rich-text ">
                                <h5>Managing our marketing relationships</h5>
                                <br/>
                                <p>Our third party marketing partners may set cookies before you reach our site.&nbsp; If you wish to prevent this type of cookie (sometimes known as a ‘third party’ or ‘analytical’ cookie), you may do so through your device’s browser security settings.</p>
                                <p>You’ll sometimes see our advertising or special offers on other websites. Cookies provided by the other website or advertising network can tell us how effective this is.&nbsp; For example, if you click on one of our advertisements, the website owner might use a cookie to tell us that you came from their site.<br />
                                    &nbsp;</p>
                            </div>
                            <div className="comp-rich-text ">
                                <h5>Giving you a better online experience and tracking website performance</h5>
                                <br/>
                                <p>You’ll still be able to use most of our online services, but some things might not work as you may expect if you do not allow us to store and access cookies on your device.</p>
                                <ul>
                                    <li>These cookies make our online services easier to use and help us to understand how people use our websites. For example, amongst other things they will:</li>
                                    <li>Make online banking login faster by remembering you between visits on your personal devices</li>
                                    <li>Simplify online transactions by remembering the online preferences you set</li>
                                    <li>Display your transactions as you like them by remembering which panels you’ve expanded and collapsed</li>
                                    <li>Remembering relevant information as you browse from page to page to save you re-entering the same information repeatedly<br />
                                        We also use this type of cookie to understand how visitors use our online services and look for ways to improve them. For example, a cookie might tell us that lots of people give up on an application process at a particular step – so we can try to make that step easier to use.<br />
                                        &nbsp;</li>
                                </ul>
                            </div>
                            <div className="comp-rich-text ">
                                <h5>Helping us make our website more relevant to you</h5>
                                <br/>
                                <p>Enabling us to customise your online experience based upon your individual circumstances, existing product holdings or activities during previous visits to this website.&nbsp; Select below given "Manage Preference" button to update cookie preferences.</p>
                                <p>These cookies are used to ensure that we present you with product promotions and offers that are relevant to you.&nbsp; For example, if you have a personal account with us we will be able to recognise this and avoid showing you special offers that are only available to people with business accounts.<br />
                                    &nbsp;</p>
                            </div>
                            <div className="comp-rich-text ">
                                <h5>Are you happy for us to use cookies?</h5>
                                <p>Some features that are designed to give you a better online experience only work if we use cookies.</p>
                                <p>You can change your mind at any time but, for now, are you happy for us to store and access cookies on your device for the purposes described?</p>
                            </div>

                        </div>                        
                        <br />
                        <button id="ot-sdk-btn" className="btn btn btn-primary cookieButton ot-sdk-show-settings" onClick={()=>{window.Optanon.ToggleInfoDisplay()}}> Manage Preference</button>
                        <br/>
                    </div>
                </div>
            </div>

        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CookiePolicy);



// WEBPACK FOOTER //
// ./src/components/CookiePolicy.js